import dayjs from "dayjs"

export const clearFilterData = {
  AptTmSt: null,
  AptTmEd: null,
  FinDteSt: null,
  FinDteEn: null,
  DrvId: null,
  SalDte: null,
  JobOrdId: null,
  ContNo: null,
  JobNo: null,
  IsFilterSalDte: 1
}

export const initFilterData = {
  ...clearFilterData
}



export const initShoreBalData = {
  PCPrdTm: dayjs(),
  PCJnlId: null,
  PCJnlNm: "",
  PrevBal: 0,
  RecvAmnt: 0,
  ExpAmnt: 0,
  NewBal: 0,
  Rmk: "",
}

export const clearPCPeriodFilterData = {
  PCPrdTmSt: null,
  PCPrdTmEn: null,
  PCJnlId: null
}
export const initPCPeriodFilterData = {
  ...clearPCPeriodFilterData,
  PCPrdTmSt: dayjs().add(-7, 'day').format("YYYY-MM-DD 00:00:00"),
  PCPrdTmEn: dayjs().format("YYYY-MM-DD 23:59:59")
}